import React from "react";
import { NavLink } from "react-router-dom";
import { MessageCircle, Users, Building2, Banknote, Calendar, BookOpen, Users2 } from "lucide-react";
import useGroupsConfig from "@/hooks/useGroupsConfig";

const ITEMS = [
  { to: "/chatter", label: "Chatter", icon: MessageCircle },
  { to: "/people", label: "People", icon: Users },
  { to: "/businesses", label: "Business", icon: Building2 },
  { to: "/capital", label: "Capital", icon: Banknote },
  // Groups (GRP-DEC-027) — shown only when the safe Groups config makes it visible.
  { to: "/groups", label: "Groups", icon: Users2, groups: true },
  { to: "/events", label: "Events", icon: Calendar },
  { to: "/resources", label: "Resources", icon: BookOpen },
];

/**
 * Mobile tab bar for jumping between the main pages. Mobile only (hidden on lg+).
 *
 * Sits directly beneath the main nav (sticky at `top-16`, the header's height) so it
 * stays one tap away while scrolling. Deliberately sticky rather than fixed: it occupies
 * real layout space, so page titles, the Local Mode toggle and Add-business buttons flow
 * below it and can never end up hidden behind it.
 */
export function MobileNavTabs() {
  const { visible: groupsVisible } = useGroupsConfig();
  const items = ITEMS.filter((it) => !it.groups || groupsVisible);
  return (
    <nav
      data-so-chrome
      className="sticky top-16 z-30 border-b border-border bg-[#f7f7f7] lg:hidden"
      style={{ paddingTop: "10px", paddingBottom: "10px" }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-[540] transition-colors ${isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"}`
            }
            data-testid={`bottom-nav-${it.label.toLowerCase()}`}
          >
            <it.icon className="h-5 w-5 text-primary" />
            <span className="leading-none">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

// Kept for existing imports; the bar is no longer at the bottom.
export const MobileBottomNav = MobileNavTabs;

export default MobileNavTabs;
